import { Injectable } from "@angular/core";
import { BaseclientService } from "../baseclient.service";
import { BehaviorSubject, Observable, from } from "rxjs";
import { map } from "rxjs/operators";
import { ToolsService } from "../../tools/tools.service";
import {SalemethodService} from "../../api/salemethod/salemethod.service";
import { Address } from "src/app/models/interfaces/address.interface";

@Injectable({
  providedIn: "root",
})
export class ClientaddressesService {
  [x: string]: any;
  private addresses: BehaviorSubject<any> = new BehaviorSubject(null);
  private delivryAddress: BehaviorSubject<any> = new BehaviorSubject(null);
  private billingAddress: BehaviorSubject<any> = new BehaviorSubject(null);

  get getDelivryAddress(): Observable<any> {
    return this.delivryAddress.asObservable();
  }

  get getBillingAddress(): Observable<Address> {
    return this.billingAddress.asObservable();
  }

  get getAddresses(): Observable<any> {
    return this.addresses.asObservable();
  }

  constructor(
    private baseClient: BaseclientService,
    private tools: ToolsService
  ) {}

  setAddresses(addresses: any) {
    this.addresses.next(addresses);
  }

  setDelivryAddress(address: any) {
    this.delivryAddress.next(address);
  }

  setBillingAddress(address: any) {
    this.billingAddress.next(address);
  }

  removeDelivryAddress() {
    this.delivryAddress.next(null);
  }

  removeBillingAddress() {
    this.billingAddress.next(null);
  }

  /**
   * @description Set l'adresse par défaut
   * @param {any[]} addresses
   * @param {string} type
   * @returns {void}
   */
  setDefaultAddress(addresses: any[], type?: string): void {
    if (addresses && addresses.length > 0) {
      const defaultAddress = addresses.filter(
        (address) => address.is_default === 1
      );

      if (type === "billing") {
        this.setBillingAddress(defaultAddress[0]);
      } else if (type === "delivry") {
        this.setDelivryAddress(defaultAddress[0]);
      } else {
        const currSM = this.tools.getStor(SalemethodService.TAG_STORAGE);

        if (
          (currSM && currSM.enable_delivery > 0) ||
          (currSM && currSM.enable_shipping_cost > 0)
        ) {
          this.setDelivryAddress(defaultAddress[0]);
        }

        this.setBillingAddress(defaultAddress[0]);
      }
    }
  }

  /**
   * @description Récupère toutes les adresses du client
   * @returns {Observable<any>}
   */
  getClientAddresses(): Observable<any> {
    return from(this.baseClient.getBase("getAddresses")).pipe(
      map((addresses) => {
        this.setDefaultAddress(addresses.addresses);
        return addresses.addresses;
      })
    );
  }

  /**
   * @description Crée une adresse
   * @param {any} param
   * @param {string} type
   * @returns {Observable<any>}
   */
  createAddress(param: any, type?: string): Observable<any> {
       return from(this.baseClient.postBase("createAddress", param)).pipe(
      map((data) => {
        if (type === "billing") {
          if (!this.billingAddress.getValue() && data.code === 0) {
            this.setDefaultAddress(data.addresses, type);
          }
        } else if (type === "delivry") {
          if (!this.delivryAddress.getValue() && data.code === 0) {
            this.setDefaultAddress(data.addresses, type);
          }
        }

        return data;
      })
    );
  }

  /**
   * @description Modifie une adresse
   * @param {any} param
   * @param {string} type
   * @returns {Observable<any>}
   */
  updateAddress(param: any, type?: string): Observable<any> {
    return from(this.baseClient.postBase("updateAddress", param)).pipe(
      map((data) => {

        if (type === "billing") {
          if (data.code === 0 && this.billingAddress.getValue()) {
            this.billingAddress.next(data.updated_address);
          }
        } else if (type === "delivry") {
          if (data.code === 0 && this.delivryAddress.getValue()) {
            this.delivryAddress.next(data.updated_address);
          }
        }

        return data;
      })
    );
  }

  /**
   * @description Supprime une adresse
   * @param {number} addressID
   * @param {string} type
   * @returns {Observable<any>}
   */
  deleteAddress(addressID: number, type: string): Observable<any> {
    const addressId = {
      address_id: addressID,
    };

    return from(this.baseClient.postBase("deleteAddress", addressId)).pipe(
      map((data) => {
        if (data.addresses.length < 1) {
          this.removeBillingAddress();
          this.removeDelivryAddress();
        } else if (type === "billing") {
          if (
            this.billingAddress.getValue() &&
            this.billingAddress.getValue().address_id === addressID
          ) {
            this.setDefaultAddress(data.addresses, "billing");
          }
        } else if (type === "delivry") {
          if (
            this.delivryAddress.getValue() &&
            this.delivryAddress.getValue().address_id === addressID
          ) {
            this.setDefaultAddress(data.addresses, "delivry");
          }
        }

        return data;
      })
    );
  }

  /**
   * @description Récupère les settings d'expedition du point de vente en fonction de l'adresse de livraison
   * @return {any}
   */
  getShippingCostsSettings(): any {
    const currPOS = this.tools.getStor("point_of_sale");
    const delivryAddress = this.delivryAddress.getValue();
    const countryId = delivryAddress ? delivryAddress.id_country : 79;
    let currentCosts = null;

    if (currPOS.shipping_costs) {
      currPOS.shipping_costs.map((data:any) => {
        data.countries.map((country:any) => {
          if (parseInt(country.id) === parseInt(countryId)) {
            currentCosts = data;
          }
        });
      });
    }

    return currentCosts;
  }

  /**
   * @description Récupère les frais d'expedition en fonction d'une adresse ou d'un point relais
   * @param {any} basket
   * @param {any} relay
   * @returns {number}
   */
  getShippingPrice(basket: any[], relay?: any, debug?: any): number {

    const currPOS = this.tools.getStor("point_of_sale");
    const currSM = this.tools.getStor(SalemethodService.TAG_STORAGE);
    const delivryAddress = this.delivryAddress.getValue();

    const countryId = delivryAddress ? delivryAddress.id_country : 79;

    let shippingCosts:any = null;
    let shippingSettings:any = null;

    let totalPrice = 0;
    let totalWeight = 0;
    let shippingPrice = 0;

    /**
     * On increment les différentes données (prix totaln, poids total)
     */
    basket.map((prod) => {
      totalPrice += prod.total_ttc;
      if (prod.weight) {
        totalWeight += prod.weight * prod.quantity;
      }
    });

    /**
     * On récupère les shipping costs et shipping settings en fonction d'une adresse ou d'un point relais
     */

    if (currPOS && currPOS.shipping_costs && currSM &&currSM.enable_shipping_cost > 0) {

      /**
       * Relay
       */
      if (relay) {
        currPOS.shipping_costs.map((data:any) => {
          if (data.is_relay > 0) {
            data.countries.map((country:any) => {
              if (relay.Pays === country.code) {
                shippingCosts = data.costs;
                shippingSettings = data;
                relay.shipping_mode = data;
              }
            });
          }
        });
      }

      /**
       * Delivry adress
       */
      if (delivryAddress && !relay && currPOS.shipping_costs) {

        for (let index = 0; index < currPOS.shipping_costs.length; index++) {
          const data = currPOS.shipping_costs[index];


        // currPOS.shipping_costs.map((data) => {

          if (
            delivryAddress.shipping_mode &&
            delivryAddress.shipping_mode.id === data.id
          ) {
            data.countries.map((country:any) => {
              if (parseInt(country.id) === parseInt(countryId)) {
                shippingCosts = data.costs;
                shippingSettings = data;
              }
            });

            if (!shippingCosts) {

              return -2;
            }
          }
        }
      }
    }



    /**
     * On récupère le bon prix en fonction du poids
     */
    if (
      currSM &&
      currSM.enable_shipping_cost > 0 &&
      basket.length > 0 &&
      shippingCosts
    ) {
      if (totalWeight > shippingCosts[shippingCosts.length - 1].max_weight) {
        return -1; //Poids trop gros
      } else {
        for (let i = 0; i < shippingCosts.length; i++) {
          let ship = shippingCosts[i];
          if (totalWeight <= ship.max_weight) {
            shippingPrice = ship.shipping_price;

            break;
          }
        }
      }
    }

    if (
      shippingSettings &&
      shippingSettings.offered_from &&
      totalPrice > shippingSettings.offered_from
    ) {

      return 0;
    }

    return Math.round(shippingPrice * 100) / 100;
  }

  /**
   * @description Récupère les settings de livraison du point de vente
   * @return {any}
   */
  getDelivrySettings(): any {

    const currPOS = this.tools.getStor("point_of_sale");
    const delivryAddress = this.delivryAddress.getValue();

    const cityId = delivryAddress ? delivryAddress.id_city : "";

    let delivrySettings = null;

    if (currPOS.eligible_zones && delivryAddress) {

      currPOS.eligible_zones.map((zone:any) => {
        if (parseInt(zone.id_city) === parseInt(cityId)) {
          delivrySettings = zone;
        }
      });
    }

    return delivrySettings;
  }
}
